module.exports = __webpack_public_path__ + "static/media/israa.045d6ece.jpg";